'use client';

import { usePageLoadTracking, useScrollTracking } from '@nrdy-marketing-engine/tracking';
import useUncaughtBrowserError from '@nrdy-marketing-engine/tracking/src/use-uncaught-browser-error';
import useSegmentPosthogSync from './use-segment-posthog-sync';

export default function Tracking() {
  useSegmentPosthogSync();
  useScrollTracking();
  usePageLoadTracking();
  useUncaughtBrowserError();
  return null;
}
